import React from "react";

/**
 * Captura errores en la subárbol y muestra un mensaje en lugar del overlay genérico "Script error."
 */
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      const msg = this.state.error?.message || String(this.state.error);
      return (
        <div style={{ padding: 20, background: "#fff5f5", border: "1px solid #feb2b2", borderRadius: 8, margin: 16 }}>
          <strong style={{ color: "#c53030" }}>Error en la aplicación</strong>
          <pre style={{ marginTop: 8, fontSize: 12, overflow: "auto", whiteSpace: "pre-wrap" }}>{msg}</pre>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            style={{ marginTop: 12, padding: "8px 16px", cursor: "pointer" }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
